import React, { useState, useEffect } from "react";
import BannerImage from "../Assets/home/lipe_hero.PNG";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";
import "./Home.css";


const Home = () => {
  const [counters, setCounters] = useState([
    { id: 1, value: 0, target: 20,  text: "pódios como treinador", prefix: "+", suffix: "" },
    { id: 2, value: 0, target: 500, text: "vidas transformadas",   prefix: "+", suffix: "" },
    { id: 3, value: 0, target: 4,   text: "Top 1 Men's Physique",  prefix: "+", suffix: "x" },
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounters(prev =>
        prev.map(c =>
          c.value < c.target
            ? { ...c, value: Math.min(c.value + Math.ceil(c.target / 25), c.target) }
            : c
        )
      );
    }, 200);
    return () => clearInterval(interval);
  }, []);

  const handleSaibaMaisClick = () => {
    document.getElementById("black-friday")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="home" id="home" data-animate="fade-right" data-delay="200">
      <Navbar />

      <div className="home-banner" data-animate="fade-up" data-delay="200">

        <h1 className="home-title">
          Junte-se à <span className="home-highlight">equipe</span> e
          transforme <span className="home-highlight">seu físico.</span>
        </h1>

        <div className="home-image">
          <img src={BannerImage} alt="Luís Felipe Sabóia" />
        </div>

        <div className="home-text">
          <p className="home-description">
            Consultoria esportiva de alto rendimento com Luís Sabóia, atleta e
            treinador com acompanhamento especializado do iniciante ao fisiculturista.
          </p>

          <button className="home-cta" onClick={handleSaibaMaisClick}>
            Aproveitar a Black Friday <FiArrowRight />
          </button>

          <div className="home-stats">
            <div className="home-stats-grid">
              {counters.map(counter => (
                <div key={counter.id} className="home-stat">
                  <div className="home-stat-number">
                    {counter.prefix}
                    <span className="home-stat-value">{counter.value}</span>
                    {counter.suffix}
                  </div>
                  <div className="home-stat-label">{counter.text}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;